import { SaveEmailTemplatesRequest, TestEmailTemplateRequest, ViewEmailTemplatesRequest } from './email-template.types';

import { API_HOST, HttpGetOptions, HttpPostOptions, getHttpGetOptions, getHttpPostOptions } from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/email-template`;

export const getSaveEmailTemplatesRequest = (
  data: SaveEmailTemplatesRequest
): [string, HttpPostOptions<SaveEmailTemplatesRequest>] => [getEndpoint(), getHttpPostOptions(data)];

export const getViewEmailTemplatesRequest = (data: ViewEmailTemplatesRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/programme/${data.programmeExternalReference}`,
  getHttpGetOptions(undefined, { type: data.type })
];

export const getTestEmailTemplateRequest = (
  data: TestEmailTemplateRequest
): [string, HttpPostOptions<TestEmailTemplateRequest>] => [`${getEndpoint()}/test`, getHttpPostOptions(data)];
